module.exports = __webpack_public_path__ + "img/signs11.b0405a33.jpg";